import { IdConta, IdInbox, IdQuadro, IdUsuario } from "@/services/common-types";
import type { DefaultBoardNames } from "@/services/contas/contas.service";
import { CreateQuadroKanban, QuadroKanbanService, ResponseQuadroKanban, UpdateQuadroKanban } from "@/services/kanban/quadro-kanban.service";
import { defineStore } from "pinia";

export const useQuadroKanbanStore = defineStore('quadroKanban', {
    state: () => ({
        initialized: false as boolean,
        idUsuario: undefined as IdUsuario|undefined,
        quadros: [] as ResponseQuadroKanban[],
        service: new QuadroKanbanService(),
        idConta: undefined as IdConta|undefined,
    }),
    actions: {
        getDefault() {
            const defaultQuadro = {
                idConta: '',
                nome: '',
                tipo_mensagem_movimentacao: "NENHUMA",
                visibilidade: "PESSOAL",
                idUsuario: '',
                mensagem_movimentacao_entrada: '',
                template_movimentacao_entrada: '',
                tipo_mensagem_movimentacao_meta: "NENHUMA",
                id_meta_template_movimentacao_entrada: '',
                meta_template_params_movimentacao_entrada: undefined,
                tipo_automacao_agendada_meta: "NENHUMA",
                tipo_automacao_agendada: "NENHUMA",
                mensagem_automacao_agendada: '',
                template_automacao_agendada: '',
                id_meta_template_automacao_agendada: '',
                meta_template_params_automacao_agendada: undefined,
                id_bot_automacao_agendada: '',
                dias_automacao_agendada: undefined,
                horario_automacao_agendada: '',
                inboxes: [] as IdInbox[],
            } as CreateQuadroKanban;
            return {...defaultQuadro};
        },
        async init(idUsuario: IdUsuario) {
            if (this.initialized) return;

            if (idUsuario) this.idUsuario = idUsuario;
            if (!this.idUsuario) throw new Error('Store inicializada sem ID de usuário.');

            this.quadros = await this.service.getAll();

            this.initialized = true;
            return this;
        },
        async reloadForConta(idConta: IdConta) {
            this.idConta = idConta;
            this.quadros = await this.service.getAll(undefined, idConta);
            return this;
        },  
        async getAll(search?: string) {
            const res = await this.service.getAll(search);
            this.quadros = res;
            return res;
        },
        async getById(id: IdQuadro, search?: string) {
            console.log(search);
            return await this.service.getById(id);
        },
        async create(quadro: CreateQuadroKanban) {
            const res = await this.service.create(quadro);
            await this.getAll();
            return res;
        },
        async update(quadro: UpdateQuadroKanban) {
            const res = await this.service.update(quadro);
            await this.getAll();
            return res;
        },
        async delete(idQuadro: IdQuadro) {
            const res = await this.service.delete(idQuadro);
            await this.getAll();
            return res;
        },
        async updateDefaultBoardNames(idConta: IdConta, names: DefaultBoardNames): Promise<void> {
            await this.service.updateDefaultBoardNames(idConta, names as Record<string, string>);
        },
        /**
         * Grava a nova ordem dos quadros deste usuário.
         *
         * Aplica localmente antes de chamar o servidor — o arraste tem que responder na hora —
         * e devolve as ordens antigas se a requisição falhar.
         */
        async reordenar(ids: IdQuadro[]): Promise<void> {
            const ordensAnteriores = new Map(this.quadros.map(q => [q.id as string, q.ordem ?? null]));

            ids.forEach((id, ordem) => {
                const quadro = this.quadros.find(q => q.id === id);
                if (quadro) quadro.ordem = ordem;
            });

            try {
                await this.service.reordenar(ids);
            } catch (e) {
                this.quadros.forEach(q => { q.ordem = ordensAnteriores.get(q.id as string) ?? null });
                throw e;
            }
        }
    }
});